interface ElegantSectionTitleProps {
  tag?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
}

export default function ElegantSectionTitle({
  tag,
  title,
  subtitle,
  align = 'left',
  light = false,
}: ElegantSectionTitleProps) {
  const textColor = light ? '#FFFFFF' : '#1A1A1A';
  const mutedColor = light ? 'rgba(255,255,255,0.5)' : '#7A7569';
  const lineColor = light ? 'rgba(201,162,39,0.4)' : 'rgba(201,162,39,0.6)';

  return (
    <div className={`${align === 'center' ? 'text-center' : ''}`}>
      {tag && (
        <div className={`flex items-center gap-3 mb-4 ${align === 'center' ? 'justify-center' : ''}`}>
          {align === 'left' && (
            <div
              className="w-10 h-px"
              style={{ background: `linear-gradient(90deg, #C9A227, transparent)` }}
            />
          )}
          <p
            className="text-xs tracking-widest-plus uppercase"
            style={{
              color: '#C9A227',
              fontFamily: "'Inter', sans-serif",
              fontWeight: 500,
            }}
          >
            {tag}
          </p>
          {align === 'center' && (
            <div
              className="w-10 h-px"
              style={{ background: `linear-gradient(90deg, transparent, #C9A227)` }}
            />
          )}
        </div>
      )}
      <h2
        className="text-2xl md:text-3xl lg:text-4xl leading-snug mb-4"
        style={{
          fontFamily: "'Noto Serif JP', 'Playfair Display', serif",
          fontWeight: 500,
          color: textColor,
          letterSpacing: '0.03em',
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className="text-sm md:text-base leading-relaxed max-w-2xl"
          style={{
            color: light ? 'rgba(255,255,255,0.7)' : '#333333',
            fontFamily: "'Noto Sans JP', 'Hiragino Kaku Gothic ProN', 'Meiryo', sans-serif",
            fontWeight: 400,
          }}
        >
          {subtitle}
        </p>
      )}
      {/* Decorative line */}
      <div
        className={`mt-6 ${align === 'center' ? 'mx-auto' : ''}`}
        style={{
          width: '48px',
          height: '1px',
          background: lineColor,
        }}
      />
    </div>
  );
}